import { configureStore } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";
import { Dispatch, combineReducers } from "redux";
import coreReducer from "./core";
import { attendanceFormSessionDetailsSlice } from "AttendanceForm/Store/Areas/AttendanceFormEvent/state";
import { persistedBookingJourneyReducer } from "./bookingJourney";
import newLearningRequestReducer from "./newLearningRequest";
import { getObjectByKey } from "utils/helpers";
import { BOOKING_JOURNEY, SESSION_STORAGE_KEYS } from "utils/constants";
import { persistStore } from "redux-persist";

const reducer = combineReducers({
  core: coreReducer,
  attendanceForm: combineReducers({
    attendanceFormSessionDetails: attendanceFormSessionDetailsSlice.reducer,
  }),
  bookingJourney: persistedBookingJourneyReducer,
  newLearningRequest: newLearningRequestReducer,
});

const store = configureStore({
  reducer,
  devTools: process.env.NODE_ENV !== "production",
  preloadedState: { ...getObjectByKey(BOOKING_JOURNEY, SESSION_STORAGE_KEYS.APPLICATION_STATE) },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: {
      ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
    },
  }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = (): Dispatch => useDispatch<AppDispatch>();

export * from "./actionTypes";
export default store;
export const persistedStore = persistStore(store)
